import useOrganizationName from '@/hooks/useOrganizationName';
import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetEquipmentsAvailability = (equipmentId: string) => {
  const organizationName = useOrganizationName();

  return useQuery({
    queryKey: ['equipmentAvailability', equipmentId, organizationName],
    queryFn: () => api.equipments.getEquipmentsAvailability(equipmentId)
  });
};
export default useGetEquipmentsAvailability;
